var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dummy"},[_vm._t("default",function(){return [_c('f-container',[_c('pre',[_vm._v(_vm._s(_vm.propses))])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }